export const validateInputs = ({ textbox2, selectedYear, difficulty, selectedSubjects }, setErrors) => {
    const newErrors = {
      countError: !textbox2 ? 'Question Count is required.' : '',
      yearError: !selectedYear ? 'Year group selection is required.' : '',
      difficultyError: !difficulty ? 'Difficulty selection is required.' : '',
      subjectError: !selectedSubjects || selectedSubjects.length === 0 ? 'At least one lesson must be selected.' : '',
    };
  
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };
  
  // The server owns the generation instructions; send only what the teacher chose.
  export const buildExamRequest = (textbox2, difficulty, selectedYear, selectedSubjects, region) => {
    const topics = Array.isArray(selectedSubjects) ? selectedSubjects : [selectedSubjects].filter(Boolean);

    return {
      prompt: `${textbox2} ${difficulty}-level maths questions for ${selectedYear} students on: ${topics.join(", ")}`,
      region,
      difficulty,
      topics,
      yearGroup: selectedYear,
      count: Number(textbox2),
    };
  };
  
  export const initializeJoyride = (setRun) => {
    const hasVisitedBefore = localStorage.getItem('hasVisited');
    if (!hasVisitedBefore) {
      setRun(true);
      localStorage.setItem('hasVisited', 'true');
    }
  };
  